import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";

import settings from "../../../../utils/settings";
import defaultErrorHandler from "../../../../actions/global/default-error-handler";
import PenaltyModal from "./penalty-modal";
import Loading from "../../../lib/Loading";

const URL = `${settings.iPayUrl}api/admin/penalty`;

const Penalties = ({
                     userId,
                     openCustomModal,
                     closeCustomModal
                   }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);

  const getList = useCallback(
    (walletId) => {
      if (!walletId) {
        return;
      }
      setIsLoading(true);
      axios.get(URL, {
        params: {
          userId: walletId
        }
      })
        .then(response => setList(response.data.content))
        .catch(error => {
          defaultErrorHandler(error, "error");
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [],
  );

  const handleAddPenalty = () => {
    const modalObj = {
      id: "modal-add-penalty",
      modalSettings: {
        size: "sm"
      },
      header: "Add Penalty",
      handleClose: () => closeCustomModal(modalObj),
      children: (
        <PenaltyModal userId={userId} onCancel={(shouldMakeRequest) => {
          if (shouldMakeRequest) {
            getList(userId);
          }
          closeCustomModal(modalObj);
        }}/>
      ),
    };
    openCustomModal(modalObj);
  };

  useEffect(() => {
    getList(userId);
  }, [userId, getList]);

  return (
    <div>
      <div className="text-right">
        <button className="btn btn-sm btn-warning mb-2" onClick={handleAddPenalty}>Add penalty</button>
      </div>
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <thead>
        <tr>
          <th>
            Amount
          </th>
          <th>
            Comment
          </th>
          <th>
            Paid
          </th>
          <th>
            Paid at
          </th>
          <th>
            Created at
          </th>
        </tr>
        </thead>
        <tbody>
        {list.map((item, index) => (
          <tr key={index}>
            <td>{item.amount}</td>
            <td>{item.comment}</td>
            <td className={item.paid ? "text-success" : "text-danger"}>{item.paid ? "Yes" : "No"}</td>
            <td>{item.paidAt ? moment(item.paidAt)
              .format("HH:mm YYYY-MM-DD") : "N/A"}</td>
            <td>{item.createdAt ? moment(item.createdAt)
              .format("HH:mm YYYY-MM-DD") : "N/A"}</td>
          </tr>
        ))}
        </tbody>
      </table>
      <Loading state={isLoading}/>
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
  null,
  mapStateToDispatch
)(Penalties);



// WEBPACK FOOTER //
// ./src/views/pages/users/penalties/index.js